export default {
    methods: {
        getParentByClassName: function(el, className) {
            while (el) {
                if (el && el.classList && el.classList.contains(className)) {
                    return el;
                } else {
                    el = el.parentNode;
                }
            }
        },
        getParentByTagName: function(el, tagName) {
            while (el) {
                if (el && el.tagName == tagName.toUpperCase()) {
                    return el;
                } else {
                    el = el.parentNode;
                }
            }
        }
    }
};
